import {useMemo} from "react";
import moment from "moment";

const useSubscriptionPeriods=()=> {
    return useMemo(() => {
       const result =[];
       const startDate = moment("2026-01-01").startOf('month');
       const today = new moment();
       let current = startDate.clone();
         while (current.isSameOrBefore(today, 'month')) {
             const periodStart = current.clone().startOf('month');
             const periodEnd = current.clone().endOf('month');
                result.push({
                    label: `${periodStart.format("YYYY/MM/DD")} - ${periodEnd.format("YYYY/MM/DD")}`,
                    value: `${periodStart.format("YYYY/MM/DD")} - ${periodEnd.format("YYYY/MM/DD HH:mm:ss")}`
                });
             current.add(1, 'month');
         }
         return result.reverse();
    }, []);

}
export default useSubscriptionPeriods;